import React, { useEffect, useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import { completeReviewAction, PublishDocAction, viewDocAction, viewTranslationsJobAction } from '../../redux/actions/translationAction';
import TranslatedDocFileViewer from '../../components/viewers/docs-viewer';
import { IoArrowBack } from 'react-icons/io5';
import { availableLanguages } from '../../components/data/languageData';
import CustomButton from '../../components/button/button';
import successToast from '../../components/toasts/successToast';
import { fileDownload, getLangName } from '../../components/helper';
import moment from 'moment';
import ComplianceReportModal from '../../components/modals/confirmation/proofinModal';
import { useAuth } from '../../context/AuthContext';

const ViewRecentTranslation = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { isAdmin, isTeamLead } = useAuth();
    const [documentData, setDocumentData] = useState(null)
    const [loading, setLoading] = useState(true); // Don't load initially
    const [targetFileUrl, setTargetFileUrl] = useState(null);
    const documentDataRef = useRef(null);
    const [showModal, setShowModal] = useState(false);

    const location = useLocation();
    const is_review = location.state?.is_review || false;


    const onSuccess = (data) => {
        const documentData = data?.data?.data;
        setDocumentData(documentData);
        documentDataRef.current = documentData;
        setTimeout(() => {
            dispatch(viewDocAction({ jobId: id }, onFetchDocSuccess, onError));
        }, 500);
    };
    const onFetchDocSuccess = (data) => {
        setTargetFileUrl(data.data.data);
        setLoading(false)
    }
    const onError = (data) => {
        errorToast(data?.data?.message);
        setLoading(false);
    };

    useEffect(() => {
        if (id) {
            dispatch(viewTranslationsJobAction({ id }, onSuccess, onError));
        }
    }, [id]);

    const handleCompleteReview = () => {
        dispatch(completeReviewAction({ id }, (data) => navigate('/post-editing'), onError));
    }

    const handlePublishClick = (id) => {
        setLoading(true);
        dispatch(PublishDocAction({ ids: id }, onPublishSuccess, onError));
    };

    const onPublishSuccess = (data) => {
        successToast(data?.data?.message);
        navigate(-1);
    };

    if (!isAdmin || isTeamLead) {
        return (
            <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <i className="bi bi-shield-lock fs_40 text-danger mb-3"></i>
                <h5 className="fw_600">Access Denied</h5>
                <p className="text-muted fs_14">This page is only accessible to company administrators and team leads.</p>
            </div>
        );
    }

    return (
        <div className='h-100 overflow-auto'>
            <div className="w-100 d-flex gap-1 align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                <span className="px-1 fs_16 cursor_pointer pb-1" onClick={() => navigate(-1)}><IoArrowBack /></span>
                <h2 className="fs_20 fw_400 fn_Roboto text-start pt-1 text-nowrap">View Recent Translation</h2>
                <div className='d-flex align-items-center justify-content-end gap-1 px-4 w-100'>
                    {is_review && (isTeamLead || isAdmin) &&
                        <CustomButton
                            className={`fs_18 fw_400 fn_Roboto mx-1 cursor_pointer text-nowrap`}
                            style={{ height: '35px', width: '150px' }}
                            variant={'primary'}
                            onClick={handleCompleteReview}
                        >
                            Complete Review
                        </CustomButton>
                    }
                    {/* <CustomButton
                        className={`fs_18 fw_400 fn_Roboto mx-1 cursor_pointer text-nowrap`}
                        style={{ height: '35px' }}
                        variant={'primary'}
                        onClick={() => setShowModal(true)}>
                        Proofing
                    </CustomButton> */}
                    {documentData && documentData?.translation_status !== 'Published' &&
                        <>
                            <CustomButton
                                className={`fs_18 fw_400 fn_Roboto mx-1 cursor_pointer text-nowrap`}
                                style={{ height: '35px' }}
                                variant={'primary'}
                                onClick={() => {
                                    navigate('/assign-user', { state: { jobs: [id], is_reassign: false } })
                                }}>
                                Send for post-editing
                            </CustomButton>

                            <CustomButton
                                className={`fs_18 fw_400 fn_Roboto mx-1 cursor_pointer text-nowrap`}
                                style={{ height: '35px' }}
                                variant={'primary'}
                                onClick={() => {
                                    handlePublishClick([id]);
                                }}
                            >
                                Publish
                            </CustomButton>
                        </>
                    }
                    {documentData && documentData?.translation_status === 'Published' &&
                        <CustomButton
                            className={`fs_18 fw_400 fn_Roboto mx-1 cursor_pointer text-nowrap`}
                            style={{ height: '35px' }}
                            variant={'primary'}
                            onClick={() => {
                                fileDownload(targetFileUrl, documentData?.file_name);
                            }}
                        >
                            Download
                        </CustomButton>
                    }

                </div>
            </div >
            {loading ?
                <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "90%" }}>
                    <Spinner animation="border" variant="primary" /> <span>Loading...</span>
                </div > :
                <div className="text-start p-3 d-flex flex-column w-100 gap-3 overflow-auto">
                    <div className='d-flex gap-2 flex-wrap'>
                        <div className="mb-2 ">
                            <label className="pb-1" >Document Name</label> <br />
                            <input type='text' style={{ width: "15rem" }} value={documentData?.file_name} disabled className='input-field' />
                        </div>
                        <div className="mb-2 ">
                            <label className="pb-1" >Source Language</label> <br />
                            <input type='text' style={{ width: "15rem" }} value={getLangName(documentData?.source_lang)} disabled className='input-field' />
                        </div>
                        <div className="mb-2 ">
                            <label className="pb-1" >Target Language</label> <br />
                            <input type='text' style={{ width: "15rem" }} value={getLangName(documentData?.target_lang)} disabled className='input-field' />
                        </div>
                        <div className="mb-2 ">
                            <label className="pb-1" >Created Date</label> <br />
                            <input type='text' style={{ width: "15rem" }} value={moment(documentData?.createdAt).format('MM/DD/YY, hh:mm A')} disabled className='input-field' />
                        </div>
                        {
                            documentData?.assignedTeams?.length > 0 &&
                            <div className="mb-2 ">
                                <label className="pb-1" >Assigned Team</label> <br />
                                <ul>
                                    {
                                        documentData?.assignedTeams?.map((item) => (
                                            <li key={item?.id}>{item?.team?.name}</li>
                                        ))}

                                </ul>
                            </div>
                        }

                        <div className="mb-2 ">
                            <label className="pb-1" >Status</label> <br />
                            <input type='text' style={{ width: "15rem" }} value={documentData?.translation_status} disabled className='input-field' />
                        </div>
                        <div className="mb-2 ">
                            <label className="pb-1" >Pages </label> <br />
                            <input type='text' style={{ width: "15rem" }} value={documentData?.no_of_pages} disabled className='input-field' />
                        </div>
                        <div className="mb-2 ">
                            <label className="pb-1" >Translated By </label> <br />
                            <input title={documentData?.user?.email} style={{ width: "15rem" }} value={documentData?.user?.email} disabled className='input-field' />
                        </div>
                        {
                            documentData.is_post_edit &&
                            <>
                                <div className="mb-2 ">
                                    <label className="pb-1" >Editor</label> <br />
                                    <input title={documentData?.editor?.email} type='text' style={{ width: "15rem" }} value={documentData?.editor?.email} disabled className='input-field' />
                                </div>
                                <div className="mb-2 ">
                                    <label className="pb-1" >Reviewed By </label> <br />
                                    <input title={documentData?.reviewer?.email} type='text' style={{ width: "15rem" }} value={documentData?.reviewer?.email} disabled className='input-field' />
                                </div>
                                <div className="mb-2 ">
                                    <label className="pb-1" >Comments </label> <br />
                                    <input title={documentData?.post_edit_comments} style={{ width: "15rem" }} value={documentData?.post_edit_comments} disabled className='input-field' />
                                </div>
                            </>
                        }

                    </div>
                    <div className={`d-flex flex-column flex-md-row gap-4`}>
                        <div className='w-100' style={{ border: '1px solid gray', borderRadius: '4px', height: '40rem' }}>
                            {documentData?.file_name?.endsWith('.pdf') || documentData?.file_name?.endsWith('.html') ? (
                                <iframe title="File Preview" src={documentData?.sourceSignedUrl} className="w-100 h-100" />
                            ) : (
                                <TranslatedDocFileViewer fileUrl={documentData?.sourceSignedUrl} className="w-100 h-100" />
                            )}
                        </div>

                        <div className='w-100' style={{ border: '1px solid gray', borderRadius: '4px', height: '40rem' }}>
                            {targetFileUrl !== null && documentData?.file_name?.endsWith('.pdf') || documentData?.file_name?.endsWith('.html') ? (
                                <iframe title="File Preview" src={targetFileUrl} className="w-100 h-100" />
                            ) : (
                                <TranslatedDocFileViewer fileUrl={targetFileUrl} className="w-100 h-100" />
                            )}
                        </div>
                    </div>
                    <ComplianceReportModal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        file_url={targetFileUrl}
                        targetLangCode={documentData?.target_lang}
                    />
                </div>
            }
        </div >

    )
}

export default ViewRecentTranslation